import useDefinedContext from "hooks/useDefinedContext";
import DrawingStoreContext from "../contexts/DrawingStoreContext";

interface UseDrawingProps {}

function useDrawing(props?: UseDrawingProps) {
  return useDefinedContext(DrawingStoreContext);
}

export default useDrawing;
